

import {Component, Vue} from "vue-property-decorator"

@Component({})
export default class HomePageContentVice extends Vue {
  name!: "HomePageContentVice"

  pathToPics = require.context('@/assets/', false, /\.[svjpn]{2}g$/);

  getPic(name: string): string {
    return this.pathToPics('./'.concat(name))
  }

}
